"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return <RadioGroupPrimitive.Root ref={ref} className={cn("grid gap-2", className)} {...props} />;
});
RadioGroup.displayName = "RadioGroup";

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "flex h-4 w-4 items-center justify-center rounded-full border border-cede-border-container transition-colors duration-150",
        "data-[state=checked]:border-cede-primary data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed",
        "focus-visible:ring-2 focus-visible:ring-cede-primary focus-visible:ring-offset-2",
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        aria-hidden
        className="flex h-2 w-2 rounded-full bg-cede-primary transition-opacity duration-150 data-[state=checked]:opacity-100 data-[state=unchecked]:opacity-0"
      />
    </RadioGroupPrimitive.Item>
  );
});
RadioGroupItem.displayName = "RadioGroupItem";

export { RadioGroup, RadioGroupItem };
